"use strict";

_BannerFlowApp.directive("colorpicker", function () {
    return {
        priority: 0,
        require: "?ngModel",
        link: function (scope, element, attrs, controller) {
            var updateModel;

            var preview = $(".color-preview-inner", $(element).prev());

            var input = $(element);

            preview.css("background-color", controller.$modelValue);

            var instance = element.colorpicker({ format: "rgba", hasText: true });
            element.on("changeColor", function (e) {
                var rgb = e.color.toRGB();
                color =
                    "rgba(" +
                    Math.max(1, rgb.r) +
                    "," +
                    Math.max(1, rgb.g) +
                    "," +
                    Math.max(1, rgb.b) +
                    "," +
                    rgb.a +
                    ")";

                preview.css("background-color", color);
            });

            scope.$watch(
                function () {
                    return controller.$modelValue;
                },
                function (newVal, oldVal) {
                    preview.css("background-color", newVal);
                },
                true
            );
        }
    };
});
